<template>
  <v-carousel
    :height="carouselHeight"
    :width="carouselWidth"
    light
    :hide-delimiters="allowCarouselDialog"
    align="center"
    justify="center"
    :show-arrows="true"
    :continuous="false"
  >
    <productImageCarouselDialog
      :showDialog="showCarouselDialog"
      :product="product"
      :carouselWidth="800"
      @close="showCarouselDialog = $event"
    />
    <v-carousel-item
      v-for="(imageModel, i) in product.productImageModels"
      :key="i"
      reverse-transition="fade-transition"
      transition="fade-transition"
      align="center"
      justify="center"
      style="background-color: white; cursor: pointer"
    >
      <div class="d-flex align-center justify-center fill-height">
        <v-img
          :src="imageModel.url"
          class="ma-1"
          contain
          :max-width="carouselWidth"
          :max-height="carouselHeight"
          :alt="imageModel.url"
          justify="center"
          @click="handleCarouselItemClick"
        />
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  import productImageCarouselDialog from '@/components/configurator/subsystem/ProductImageCarouselDialog.vue';

  export default {
    components: {
      productImageCarouselDialog
    },
    props: {
      carouselHeight: {
        type: Number,
        default: 250
      },
      carouselWidth: {
        type: Number,
        default: 200
      },
      product: {
        type: Object,
        required: true
      },
      allowCarouselDialog: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showCarouselDialog: false
      };
    },
    methods: {
      handleCarouselItemClick() {
        if (this.allowCarouselDialog) {
          this.showCarouselDialog = true;
        }
      }
    }
  };
</script>

<style>
  .v-carousel__controls {
    padding-top: 5px;
    padding-bottom: 5px;
    background: #333 !important;
  }
</style>
